import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import DevExpress from 'devextreme';
import html2canvas from 'html2canvas';
import { AppHotelService } from '../../../provider/app-hotel.service';
import { ItemService } from '../../../provider/item.service';
import { AppHotelModel } from '../../models/app-hotel.model';
import { MenuItemCapacity } from '../../models/capacity.model';
import data = DevExpress.data;

@Component({
  selector: 'c-capacity',
  templateUrl: './capacity.component.html',
  styleUrls: ['./capacity.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class CapacityComponent implements OnChanges, OnInit {
  @Input() ID: number;

  generated = [];

  loaded = false;

  qrData: string = null;
  qrTitle: string = null;
  qrDisplay = false;
  imageData: any = null;

  hotelData: AppHotelModel = null;

  options = {
    location: null,
    capacity: null,
    adultcapacity: null,
    quantity: 1,
    start: 0,
    prefix: null,
    suffix: null,
    increment: 1,
    seperator: null,
    description: null,
    price: 0
  };

  constructor(
    private mdlctrl: NgbModal,
    public itemServ: ItemService,
    private appHotel: AppHotelService,
    private changeDetect: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.appHotel.getHotelInfo(this.appHotel.popupHotelId || Number(JSON.parse(localStorage.getItem('token_form')).app_hotel_id)).subscribe((resp: AppHotelModel) => {
      this.hotelData = resp;
    });
  }

  refresh() {
    this.changeDetect.detectChanges();
  }

  ngOnChanges() {
    this.loaded = true;
    this.itemServ.getCapacities(this.ID);
    this.itemServ.capacity_change$.subscribe(resp => {
      console.log(resp);
    });
  }

  generateQr(table, banner: HTMLElement) {
    this.qrData = `https://${this.hotelData.sub_domain_name}.guestny.com/${this.hotelData.sub_domain_name}?table=${table.no}`;
    this.qrTitle = `${table.location} ${table.no}`;
    this.qrDisplay = true;

    this.convert(banner);
  }

  convert(div: HTMLElement) {
    const bannerdiv: HTMLElement = document.getElementById('banner-div');

    window.scrollTo(0, 0);
    bannerdiv.style.display = 'flex';

    document.body.append(bannerdiv);

    this.refresh();

    const options = {
      dpi: 1500, // Set to 300 DPI
      scrollY: -window.scrollY,
      scrollX: 0,
      allowTaint: true,
      scale: 1.5,
      backgroundColor: 'white',
      useCORS: true
    };

    setTimeout(() => {
      html2canvas(div, options).then(canvas => {
        this.imageData = canvas.toDataURL('image/png');
        this.convertblob(canvas.toDataURL('image/png'));
      });

      setTimeout(() => {
        this.qrDisplay = false;
        bannerdiv.style.display = 'none';
      }, 100);
    }, 300);

  }

  download() {
    const link = document.createElement('a');
    link.download = 'html_image.png';
    link.href = this.imageData;
    link.target = '_blank';
    link.click();
  }

  convertblob(img: string) {
    const base64ImageData = img;
    const contentType = 'image/png';

    const byteCharacters = atob(base64ImageData.substr(`data:${contentType};base64,`.length));
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, '_blank');
    this.download();
    this.refresh();
  }


  open(modal: any) {
    this.mdlctrl.open(modal, { windowClass: 'capacity-modal', size: 'lg' });
  }

  async deleteNo(id: number) {
    await this.itemServ.deleteCapacity(id);
    this.itemServ.getCapacities(this.ID);
  }

  async update(data: MenuItemCapacity) {
    await this.itemServ.putCapacities([data]);
    this.itemServ.getCapacities(this.ID);
  }

  generate() {
    let number: number = this.options.start;
    this.options.prefix = this.options.prefix || '';
    this.options.suffix = this.options.suffix || '';
    this.options.seperator = this.options.seperator || '';

    for (let i = 0; i < this.options.quantity; i++) {
      const generatedNo = `${this.options.prefix}${this.options.prefix !== '' ? this.options.seperator : ''}${number}${this.options.suffix !== '' ? this.options.seperator : ''}${this.options.suffix}`;

      const GENERATED: MenuItemCapacity = new MenuItemCapacity();

      GENERATED.id = 0;
      GENERATED.hotel_id = Number(JSON.parse(localStorage.getItem('token_form')).app_hotel_id);
      GENERATED.adult_capacity = this.options.adultcapacity;
      GENERATED.capacity = this.options.capacity;
      GENERATED.adult_capacity = this.options.adultcapacity;
      GENERATED.description = this.options.description;
      GENERATED.location = this.options.location;
      GENERATED.menu_item_id = this.ID;
      GENERATED.status = true;
      GENERATED.no = generatedNo;

      this.generated.push(GENERATED);

      number += this.options.increment;
    }

    this.options = {
      location: null,
      capacity: null,
      adultcapacity: null,
      quantity: 1,
      start: 0,
      prefix: null,
      suffix: null,
      increment: 1,
      seperator: null,
      description: null,
      price: 0
    };

    this.itemServ.postCapacities(this.ID, this.generated);
  }
}
